/**
 * Platform RBAC — SSOT permission constants (mirror dari backend
 * `services/platform_rbac.py`).
 *
 * Digunakan oleh:
 *   - PlatformLayout: hide menu items berdasarkan permission
 *   - Halaman team: gate action buttons
 *   - Route guard: redirect kalau user tidak punya akses
 */
export const PLATFORM_ROLE = {
  OWNER: "PLATFORM_OWNER",
  ADMIN: "PLATFORM_ADMIN",
  SUPPORT: "SUPPORT",
  FINANCE: "FINANCE",
  DEVELOPER: "DEVELOPER",
  VIEWER: "VIEWER",
};

export const PLATFORM_ROLES = Object.values(PLATFORM_ROLE);

export const ROLE_LABEL = {
  PLATFORM_OWNER: "Platform Owner",
  PLATFORM_ADMIN: "Platform Admin",
  SUPPORT: "Support",
  FINANCE: "Finance",
  DEVELOPER: "Developer",
  VIEWER: "Viewer",
};

export const ROLE_DESCRIPTION = {
  PLATFORM_OWNER: "Full access ke seluruh platform (owner-only actions).",
  PLATFORM_ADMIN: "Kelola tenant, template, deployment, subscription.",
  SUPPORT: "Read-only untuk operational visibility (tenant + deployment + logs).",
  FINANCE: "Baca subscription, tenant package & logs terkait billing.",
  DEVELOPER: "Kelola template + deployment (non-billing).",
  VIEWER: "Read-only dashboard.",
};

export const ACCOUNT_STATUS = {
  ACTIVE: "ACTIVE",
  INVITED: "INVITED",
  SUSPENDED: "SUSPENDED",
  DISABLED: "DISABLED",
};

export const STATUS_LABEL = {
  ACTIVE: "Active",
  INVITED: "Invited",
  SUSPENDED: "Suspended",
  DISABLED: "Disabled",
};

export const PERMISSION = {
  USERS_READ: "platform.users.read",
  USERS_WRITE: "platform.users.write",
  TENANTS_READ: "platform.tenants.read",
  TENANTS_WRITE: "platform.tenants.write",
  TEMPLATES_READ: "platform.templates.read",
  TEMPLATES_WRITE: "platform.templates.write",
  DEPLOYMENTS_READ: "platform.deployments.read",
  DEPLOYMENTS_WRITE: "platform.deployments.write",
  SUBSCRIPTIONS_READ: "platform.subscriptions.read",
  SUBSCRIPTIONS_WRITE: "platform.subscriptions.write",
  LOGS_READ: "platform.logs.read",
  SETTINGS_READ: "platform.settings.read",
  SETTINGS_WRITE: "platform.settings.write",
};

/**
 * Check apakah user memiliki permission `perm`.
 *
 * `user.permissions` datang dari GET /platform/auth/me.
 * Bila user null/undefined → false (fail closed).
 */
export function hasPermission(user, perm) {
  if (!user || !Array.isArray(user.permissions)) return false;
  return user.permissions.includes(perm);
}

export function isOwner(user) {
  return user?.platform_role === PLATFORM_ROLE.OWNER;
}

export function canManageStaffRole(actor, targetRole) {
  // Hanya OWNER yang boleh mengelola OWNER
  if (targetRole === PLATFORM_ROLE.OWNER) return isOwner(actor);
  // ADMIN dan OWNER boleh mengelola non-owner (walau backend akan enforce lagi)
  return isOwner(actor) || actor?.platform_role === PLATFORM_ROLE.ADMIN;
}
